export default __webpack_public_path__ + "static/media/Willie Dustice.c014cd6a.jpg";